module.exports = __webpack_public_path__ + "img/824-5b00ef.png";